// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sp-ben5ho .sp-posts-single-block {
  border-radius: 7px;
  padding: 13px;
  margin-bottom: 0;
}

#sp-ben5ho .sp-posts-single-block.sp-news-posts:nth-of-type(3n + 1) {
  border-left: 0;
}

#sp-ben5ho
  .sp-layout-gridlayout
  .sp-posts-single-block.sp-minimal-posts:nth-child(-n + 3),
#sp-ben5ho
  .sp-layout-masonary
  .sp-posts-single-block.sp-minimal-posts:nth-child(-n + 3) {
  border-top: 0;
}

#sp-ben5ho .sp-layout-carousel .sp-posts-single-block.sp-minimal-posts {
  border-top: 0;
}

#sp-ben5ho .sp-posts-image {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

#sp-ben5ho .sp-posts-image-link {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  margin: 0;
}

#sp-ben5ho .sp-thumbnail {
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

#sp-ben5ho .sp-posts-block-title {
  text-align: left;
  font-size: 20px;
  font-weight: 700;
  color: #374151;
}

#sp-ben5ho .sp-posts-block-meta-text {
  text-align: left;
}

#sp-ben5ho .sp-posts-block-excerpt {
  text-align: left;
}

#sp-ben5ho .sp-posts-block-read-more {
  text-align: left;
}

#sp-ben5ho .sp-posts-block-pagination {
  text-align: left;
  font-size: px;
}

#sp-ben5ho .sp-posts-single-block .sp-container-badge {
  display: inline-block;
  color: #fff;
  background-color: #333;
  margin-bottom: undefinedpx;
}

#sp-ben5ho .sp-posts-single-block .sp-container-badge a {
  color: #fff;
}

#sp-ben5ho .sp-skin-block.sp-layout-carousel {
  gap: 0;
  flex-direction: column;
}

#sp-ben5ho .sp-skin-block.sp-layout-carousel .sp-postblock-nav {
  justify-content: center;
}

#sp-bf2x0i {
  background-color: #fff4e4;
  width: 100%;
  max-width: 100%;
  padding: 10px;
}

#sp-b3j1ub {
  width: calc(100% + 0px);
}

#sp-6r7flvguzh {
  z-index: 0;
}

#sp-bwgiu8ve02 {
  z-index: 0;
}

#sp-teojeb {
  height: 40px;
}

#sp-ds689z {
  font-size: 48px;
  text-align: center;
  margin: 0;
}

#sp-ut06xj {
  font-size: 18px;
  padding: 3px 0 0;
  margin: 0;
  text-align: center;
}

#sp-wb3isz {
  height: 0;
}

#sp-w0z2ku {
  width: auto;
  max-width: 850px;
}

@media (max-width: 768px) {
  #sp-w0z2ku {
    width: auto;
    max-width: 350px;
    margin-bottom: 20px;
  }
}

#sp-fbjtpp {
  width: calc(16.6667% + 0px);
}

#sp-rx7rbcq36q {
  z-index: 0;
}

#sp-noip8gjbhf {
  z-index: 0;
}

#sp-c3954l {
  margin: 0;
  text-align: center;
}

#sp-8qg7evbmks {
  width: 45px;
}

#sp-rcew2o {
  line-height: 1.3;
  font-size: 14px;
  padding: 2px 0 0;
  margin: 0;
  text-align: center;
}

#sp-h6bm4c {
  width: calc(16.6667% + 0px);
}

#sp-75ks273nhs {
  z-index: 0;
}

#sp-iuk0yz45fv {
  z-index: 0;
}

#sp-anpbod {
  margin: 0;
  text-align: center;
}

#sp-tgqd43uxxr {
  width: 44px;
}

#sp-z7izeg {
  line-height: 1.3;
  font-size: 14px;
  padding: 2px 0 0;
  margin: 0;
  text-align: center;
}

#sp-w3r3vo {
  width: calc(16.6667% + 0px);
}

#sp-2627k6knak {
  z-index: 0;
}

#sp-ek25ed39xq {
  z-index: 0;
}

#sp-eo00pm {
  margin: 0;
  text-align: center;
}

#sp-8rniogyxaz {
  width: 45px;
}

#sp-x3lz7g {
  line-height: 1.3;
  font-size: 14px;
  padding: 2px 0 0;
  margin: 0;
  text-align: center;
}

#sp-w7f6ni {
  width: calc(16.6667% + 0px);
}

#sp-57tae757ul {
  z-index: 0;
}

#sp-92wt676ghl {
  z-index: 0;
}

#sp-rxxrmh {
  margin: 0;
  text-align: center;
}

#sp-w7exd9s190 {
  width: 44px;
}

#sp-gugx9z {
  line-height: 1.3;
  font-size: 14px;
  padding: 2px 0 0;
  margin: 0;
  text-align: center;
}

#sp-kp3890 {
  width: calc(16.6667% + 0px);
}

#sp-c28tj6pyqc {
  z-index: 0;
}

#sp-7sg8l5x19l {
  z-index: 0;
}

#sp-bn2fcb {
  margin: 0;
  text-align: center;
}

#sp-4paaylpy56 {
  width: 44px;
}

#n3bicd {
  line-height: 1.3;
  font-size: 14px;
  padding: 2px 0 0;
  margin: 0;
  text-align: center;
  position: relative;
}

#sp-m64u5n {
  width: calc(16.6667% + 0px);
}

#sp-v9zbz4zfds {
  z-index: 0;
}

#sp-35ryj8r7un {
  z-index: 0;
}

#sp-seomfz {
  margin: 0;
  text-align: center;
}

#sp-istm31lqm1 {
  width: 44px;
}

#sp-lbrdh0 {
  line-height: 1.3;
  font-size: 14px;
  padding: 2px 0 0;
  margin: 0;
  text-align: center;
}

#sp-ui35qo {
  width: calc(100% + 0px);
}

@media only screen and (max-width: 768px) {
  #mobile-margin {
    margin-top: -20px;
  }
}

#sp-vqh2jd1uj8 {
  z-index: 0;
}

#sp-xbkc7v8bui {
  z-index: 0;
}

#sp-pwnhx4 {
  height: 0;
}

#sp-button-parent-cii6rt {
  margin: 0;
  text-align: center;
}

#sp-cii6rt {
  font-size: 20px;
  width: auto;
  padding: 22px 66px;
  border-radius: 32px;
}

#sp-rufcae {
  height: 20px;
}

#sp-bjowye {
  height: 0;
}

#sp-aqq5vl {
  /* padding: 0; */
  /* width: auto; */
  max-width: 600px;
}

@media (max-width: 768px) {
  #sp-aqq5vl {
    /* padding: 0; */
    /* width: auto; */
    max-width: 75%;
    margin-top: 40px;
    margin-bottom: 20px;
  }
}

/* Styles for web view */
#sp-cgf214 {
  width: calc(100% + 0px);
}

#sp-cgf214 .woocommerce-logo,
#sp-cgf214 .shopify-badge,
#sp-cgf214 .pabloo-trust {
  width: 183px;
  object-fit: contain;
  border-radius: 9999px;
}

#sp-cgf214 .bg-white {
  background-color: white;
  border-radius: 9999px;
}

#sp-cgf214 .px-4 {
  padding-left: 16px;
  padding-right: 16px;
}

/* Mobile-specific styles */
@media (max-width: 768px) {
  #sp-cgf214 {
    grid-template-columns: 1fr !important;
    gap: 0px !important;
  }

  #sp-cgf214 .woocommerce-logo,
  #sp-cgf214 .shopify-badge,
  #sp-cgf214 .pabloo-trust {
    width: 90% !important;
    padding-left: 16px;
    padding-right: 16px;
    border-radius: 75px;
  }

  #sp-cgf214 .flex {
    margin-top: 25px !important;
  }

  #sp-cgf214 .px-4 {
    padding-top: 10px;
    padding-bottom: 10x;
    padding-left: 16px;
    padding-right: 16px;
  }
}

#sp-d86i01 {
  margin: 0;
  padding: 0;
  text-align: center;
}

#sp-eyokvw3gyu {
  width: 183px;
  height: 46px;
}

#sp-kjpg6v {
  margin: 0;
  padding: 0 0 0 6px;
  text-align: left;
}

#sp-jth55ps0gy {
  width: 328px;
  height: 41px;
}

#sp-p7wnaf {
  margin: 0;
  padding: 0 6px 0 0;
  text-align: center;
}

#sp-aswsuum9u5 {
  width: 163px;
  height: 46px;
}

#sp-axynf7 {
  background-color: #fff4e4;
  width: 100%;
  max-width: 100%;
}

#sp-f4lgtv {
  padding: 0;
  width: 100%;
  max-width: 100%;
}

#sp-axe4hs {
  width: calc(100% + 0px);
  padding: 0;
}

#sp-kf43a4 {
  margin: 0;
  padding: 0;
  text-align: center;
}

#sp-w05e0zi3qe {
  width: 1304px;
}

#sp-g2xrn7 {
  height: 7px;
}

#sp-p2wii1 {
  width: 100%;
  max-width: 100%;
  padding: 0;
}

#sp-psqt4k {
  padding: 0;
  width: 100%;
  max-width: 100%;
}

#sp-om4w75 {
  width: calc(100% + 0px);
  padding: 0;
}

#sp-qdcv8r {
  padding: 0;
  margin: 0;
  display: flex;
}

#sp-nxlmig {
  height: 75px;
}

#sp-wyvbbw {
  background-color: #e4f7ff;
  width: 100%;
  max-width: 100%;
}

#sp-a52czq {
  width: calc(100% + 0px);
}

#sp-q24ukq {
  height: 60px;
}

#sp-xjet1i {
  text-align: center;
  margin: 0;
}

#sp-kxyn8o {
  font-size: 18px;
  margin: 0;
  text-align: center;
}

#sp-sxw0lf918d {
  font-weight: 400;
}

#sp-yteg6e {
  width: calc(100% + 0px);
}

#sp-ec3l9y {
  margin: 0;
}

#sp-button-parent-fgt5av {
  margin: 0;
  text-align: center;
}

#sp-fgt5av {
  font-size: 16px;
  font-weight: 700;
  width: auto;
  padding: 20px 58px;
  border-radius: 40px;
}

#sp-ou64nh {
  height: 60px;
}

#sp-sctek0 {
  width: 100%;
  max-width: 100%;
  padding: 0;
}

#sp-b51x9n {
  padding: 0;
  width: 100%;
  max-width: 100%;
}

#sp-an6u1r {
  width: calc(100% + 0px);
  padding: 0;
}

#sp-p19qjc {
  height: 30px;
}

#sp-a2qycu {
  padding: 0;
  margin: 0;
  display: flex;
}

#sp-vm8h5x {
  width: 100%;
  max-width: 100%;
  padding: 0;
}

#sp-eicp6k {
  width: 100%;
  max-width: 100%;
}

#sp-jn2hwe {
  width: calc(100% + 0px);
  padding: 0;
}

#sp-hunfgw {
  height: 20px;
}

#sp-g7siyz {
  font-size: 40px;
  text-align: center;
  margin: 0;
}

#sp-k3rw5m {
  padding: 0;
  margin: 0;
}

#sp-jjcbou {
  width: 100%;
  max-width: 100%;
}

#sp-w8xtzn {
  width: auto;
  max-width: 900px;
}

#sp-zu6kzg {
  width: calc(100% + 0px);
}

#sp-kgqxw8 {
  height: 40px;
}

#sp-ebuojp {
  font-size: 40px;
  text-align: center;
  margin: 0;
}

#sp-e2orzv {
  font-size: 18px;
  margin: 0;
  text-align: center;
}

#sp-y4rndf {
  height: 70px;
}

#sp-wzfbsu {
  margin: 0;
  font-size: 18px;
  color: #1f2937;
}

#sp-vvgw7w32rg {
  margin: 0 0 23px;
}

#sp-m7yjbiaxmc {
  font-weight: 700;
  color: #1f2937;
}

#sp-acc-closed-icon-id-wzfbsu {
  width: 36px;
  line-height: 36px;
  font-size: 18px;
  color: #374151;
}

#sp-acc-open-icon-id-wzfbsu {
  width: 36px;
  line-height: 36px;
  font-size: 18px;
  color: #374151;
}

#sp-08jucskpu1 {
  border-top: 1px solid #e5e7eb;
}

#sp-gwwo1k2dyi {
  margin: 23px 0;
}

#sp-jfaptgn8xc {
  font-weight: 700;
  color: #1f2937;
}

#sp-uuiiu84fk8 {
  border-top: 1px solid #e5e7eb;
}

#sp-yhadsl6tl0 {
  margin: 23px 0;
}

#sp-lygsb9n28i {
  font-weight: 700;
  color: #1f2937;
}

#sp-koqyujheft {
  border-top: 1px solid #e5e7eb;
}

#sp-m0i6i3xb5q {
  margin: 23px 0;
}

#sp-1zpipmlay9 {
  font-weight: 700;
  color: #1f2937;
}

#sp-f0sp5ggkq4 {
  border-top: 1px solid #e5e7eb;
}

#sp-zejg8zspxd {
  margin: 23px 0;
}

#sp-an5pwvxinw {
  font-weight: 700;
  color: #1f2937;
}

#sp-7n766lnczk {
  border-top: 1px solid #e5e7eb;
}

#sp-bhh1w8g7dl {
  margin: 23px 0 0;
}

#sp-qf9cfrhtq4 {
  font-weight: 700;
  color: #1f2937;
}

#sp-i1gsfyx5rw {
  border-top: 0 solid #e5e7eb;
}

#sp-m33z1h {
  height: 86px;
}

#sp-k2xwy0 {
  background-color: #fff4e4;
  width: 100%;
  max-width: 100%;
}

#sp-w4snn8 {
  width: auto;
  max-width: 1000px;
}

#sp-yp6bi4 {
  width: calc(100% + 0px);
}

#sp-txsx3txmn5 {
  z-index: 0;
}

#sp-1jucvbedvk {
  z-index: 0;
}

#sp-lkwjil {
  height: 60px;
}

#sp-kr30a0 {
  font-size: 40px;
  text-align: center;
  margin: 0;
}

#sp-u0zpwt {
  font-size: 18px;
  margin: 0;
  text-align: left;
}

#sp-cq6xxxfmo5 {
  text-align: center;
}

#sp-f03md9 {
  height: 0;
}

#sp-ben5ho {
  margin: 0;
}

#sp-uhmggu {
  height: 200px;
}

@media only screen and (max-width: 480px) {
  #sp-teojeb {
    height: 5px !important;
  }

  .sp-headline-block-ds689z,
  #sp-ds689z,
  #ds689z {
    font-size: 24px !important;
    text-align: center !important;
  }

  .sp-text-wrapper-ut06xj,
  #sp-ut06xj,
  #ut06xj {
    font-size: 16px !important;
    text-align: left !important;
  }

  #sp-wb3isz {
    height: 0 !important;
  }

  #sp-c3954l {
    text-align: center !important;
  }

  .sp-text-wrapper-rcew2o,
  #sp-rcew2o,
  #rcew2o {
    text-align: left !important;
  }

  #sp-anpbod {
    text-align: center !important;
  }

  .sp-text-wrapper-z7izeg,
  #sp-z7izeg,
  #z7izeg {
    text-align: left !important;
  }

  #sp-eo00pm {
    text-align: center !important;
  }

  .sp-text-wrapper-x3lz7g,
  #sp-x3lz7g,
  #x3lz7g {
    text-align: left !important;
  }

  #sp-rxxrmh {
    text-align: center !important;
  }

  .sp-text-wrapper-gugx9z,
  #sp-gugx9z,
  #gugx9z {
    text-align: left !important;
  }

  #sp-bn2fcb {
    text-align: center !important;
  }

  .sp-text-wrapper-n3bicd,
  #sp-n3bicd,
  #n3bicd {
    text-align: left !important;
  }

  #sp-seomfz {
    text-align: center !important;
  }

  .sp-text-wrapper-lbrdh0,
  #sp-lbrdh0,
  #lbrdh0 {
    text-align: left !important;
  }

  #sp-button-parent-cii6rt {
    text-align: center !important;
  }

  #sp-rufcae {
    height: 10px !important;
  }

  #sp-bjowye {
    height: 0 !important;
  }

  #sp-d86i01 {
    text-align: center !important;
  }

  #sp-kjpg6v {
    text-align: center !important;
  }

  #sp-p7wnaf {
    text-align: center !important;
  }

  #sp-kf43a4 {
    text-align: center !important;
  }

  #sp-g2xrn7 {
    height: 7px !important;
  }

  #sp-p2wii1 {
    padding: 0 !important;
  }

  #sp-psqt4k {
    padding: 0 !important;
  }

  #sp-om4w75 {
    padding: 0 !important;
  }

  #sp-qdcv8r {
    padding: 0 !important;
  }

  #sp-f9xti6 {
    height: 0 !important;
  }

  .sp-headline-block-qauwjx,
  #sp-qauwjx,
  #qauwjx {
    font-size: 22px !important;
    text-align: center !important;
  }

  .sp-text-wrapper-n51jiy,
  #sp-n51jiy,
  #n51jiy {
    text-align: center !important;
  }

  #sp-kgz2e9 {
    height: 0 !important;
  }

  #sp-button-parent-uwxjkd {
    text-align: center !important;
  }

  .sp-text-wrapper-xtajmm,
  #sp-xtajmm,
  #xtajmm {
    text-align: center !important;
  }

  #sp-vkyt0u {
    height: 20px !important;
  }

  #sp-nxlmig {
    height: 10px !important;
  }

  #sp-q24ukq {
    height: 10px !important;
  }

  .sp-headline-block-xjet1i,
  #sp-xjet1i,
  #xjet1i {
    text-align: center !important;
  }

  .sp-text-wrapper-kxyn8o,
  #sp-kxyn8o,
  #kxyn8o {
    text-align: center !important;
  }

  #sp-button-parent-fgt5av {
    text-align: center !important;
  }

  #sp-ou64nh {
    height: 10px !important;
  }

  #sp-sctek0 {
    padding: 0 !important;
  }

  #sp-b51x9n {
    padding: 0 !important;
  }

  #sp-an6u1r {
    padding: 0 !important;
  }

  #sp-p19qjc {
    height: 10px !important;
  }

  #sp-a2qycu {
    padding: 0 !important;
  }

  #sp-gi9fil {
    height: 30px !important;
  }

  .sp-headline-block-x353y1,
  #sp-x353y1,
  #x353y1 {
    font-size: 22px !important;
    line-height: 1.2 !important;
    text-align: center !important;
  }

  .sp-text-wrapper-ygedsp,
  #sp-ygedsp,
  #ygedsp {
    text-align: left !important;
  }

  #sp-qp2g5t {
    height: 0 !important;
  }

  #sp-obzcdd {
    text-align: center !important;
  }

  .sp-headline-block-vniws6,
  #sp-vniws6,
  #vniws6 {
    font-size: 18px !important;
    text-align: left !important;
  }

  #sp-r5wo9a {
    height: 6px !important;
  }

  .sp-text-wrapper-pzvg6s,
  #sp-pzvg6s,
  #pzvg6s {
    font-size: 14px !important;
    text-align: left !important;
  }

  .sp-headline-block-m0x996,
  #sp-m0x996,
  #m0x996 {
    font-size: 18px !important;
    text-align: left !important;
  }

  .sp-text-wrapper-p7gy29,
  #sp-p7gy29,
  #p7gy29 {
    font-size: 14px !important;
    text-align: left !important;
  }

  #sp-o40lfw {
    text-align: center !important;
  }

  #sp-ozw1av {
    text-align: center !important;
  }

  .sp-headline-block-pjvos7,
  #sp-pjvos7,
  #pjvos7 {
    font-size: 18px !important;
    text-align: left !important;
  }

  .sp-text-wrapper-i51n7b,
  #sp-i51n7b,
  #i51n7b {
    font-size: 14px !important;
    text-align: left !important;
  }

  .sp-headline-block-d7ygke,
  #sp-d7ygke,
  #d7ygke {
    font-size: 18px !important;
    text-align: left !important;
  }

  .sp-text-wrapper-jm0s0m,
  #sp-jm0s0m,
  #jm0s0m {
    font-size: 14px !important;
    text-align: left !important;
  }

  #sp-lsqp5w {
    text-align: center !important;
  }

  #sp-dggsq5 {
    text-align: center !important;
  }

  .sp-headline-block-q71rdl,
  #sp-q71rdl,
  #q71rdl {
    font-size: 18px !important;
    text-align: left !important;
  }

  .sp-text-wrapper-vd2gnm,
  #sp-vd2gnm,
  #vd2gnm {
    font-size: 14px !important;
    text-align: left !important;
  }

  .sp-headline-block-t2cyfz,
  #sp-t2cyfz,
  #t2cyfz {
    font-size: 18px !important;
    text-align: left !important;
  }

  .sp-text-wrapper-zaae5j,
  #sp-zaae5j,
  #zaae5j {
    font-size: 14px !important;
    text-align: left !important;
  }

  #sp-s1wtzk {
    text-align: center !important;
  }

  #sp-hunfgw {
    height: 10px !important;
  }

  .sp-headline-block-g7siyz,
  #sp-g7siyz,
  #g7siyz {
    font-size: 22px !important;
    text-align: center !important;
  }

  #sp-kgqxw8 {
    height: 40px !important;
  }

  .sp-headline-block-ebuojp,
  #sp-ebuojp,
  #ebuojp {
    font-size: 22px !important;
    text-align: center !important;
  }

  .sp-text-wrapper-e2orzv,
  #sp-e2orzv,
  #e2orzv {
    font-size: 14px !important;
    text-align: center !important;
  }

  #sp-y4rndf {
    height: 20px !important;
  }

  #sp-wzfbsu {
    font-size: 14px !important;
  }

  #sp-m33z1h {
    height: 40px !important;
  }

  #sp-lkwjil {
    height: 20px !important;
  }

  .sp-headline-block-kr30a0,
  #sp-kr30a0,
  #kr30a0 {
    font-size: 22px !important;
    text-align: center !important;
  }

  .sp-text-wrapper-u0zpwt,
  #sp-u0zpwt,
  #u0zpwt {
    font-size: 14px !important;
    text-align: left !important;
  }

  #sp-f5tl4t {
    padding: 0 !important;
  }

  #sp-s41od9 {
    padding: 0 !important;
  }

  #sp-ben5ho {
    padding: 0 !important;
  }

  #sp-ben5ho .sp-skin-news .sp-posts-single-block {
    border-left: 0 !important;
  }

  #sp-ben5ho .sp-posts-block-title {
    font-size: 18px !important;
    text-align: center !important;
  }

  #sp-ben5ho .sp-posts-block-meta-text {
    text-align: center !important;
  }

  #sp-ben5ho .sp-posts-single-block .sp-container-badge,
  #sp-ben5ho .sp-posts-single-block .sp-container-badge a {
    text-align: center !important;
  }

  #sp-ben5ho .sp-posts-block-excerpt {
    text-align: center !important;
  }

  #sp-ben5ho .sp-posts-block-read-more {
    text-align: center !important;
  }

  #sp-ben5ho .sp-posts-block-pagination {
    text-align: center !important;
  }

  #sp-uhmggu {
    height: 60px !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 1024px) {
  #sp-teojeb {
    height: 10px !important;
  }

  .sp-headline-block-ds689z,
  #sp-ds689z,
  #ds689z {
    text-align: center !important;
  }

  .sp-text-wrapper-ut06xj,
  #sp-ut06xj,
  #ut06xj {
    text-align: left !important;
  }

  #sp-wb3isz {
    height: 10px !important;
  }

  #sp-c3954l {
    text-align: center !important;
  }

  .sp-text-wrapper-rcew2o,
  #sp-rcew2o,
  #rcew2o {
    text-align: left !important;
  }

  #sp-anpbod {
    text-align: center !important;
  }

  .sp-text-wrapper-z7izeg,
  #sp-z7izeg,
  #z7izeg {
    text-align: left !important;
  }

  #sp-eo00pm {
    text-align: center !important;
  }

  .sp-text-wrapper-x3lz7g,
  #sp-x3lz7g,
  #x3lz7g {
    text-align: left !important;
  }

  #sp-rxxrmh {
    text-align: center !important;
  }

  .sp-text-wrapper-gugx9z,
  #sp-gugx9z,
  #gugx9z {
    text-align: left !important;
  }

  #sp-bn2fcb {
    text-align: center !important;
  }

  .sp-text-wrapper-n3bicd,
  #sp-n3bicd,
  #n3bicd {
    text-align: left !important;
  }

  #sp-seomfz {
    text-align: center !important;
  }

  .sp-text-wrapper-lbrdh0,
  #sp-lbrdh0,
  #lbrdh0 {
    text-align: left !important;
  }

  #sp-pwnhx4 {
    height: 10px !important;
  }

  #sp-button-parent-cii6rt {
    text-align: center !important;
  }

  #sp-rufcae {
    height: 10px !important;
  }

  #sp-bjowye {
    height: 10px !important;
  }

  #sp-d86i01 {
    text-align: center !important;
  }

  #sp-kjpg6v {
    text-align: center !important;
  }

  #sp-p7wnaf {
    text-align: center !important;
  }

  #sp-kf43a4 {
    text-align: center !important;
  }

  #sp-g2xrn7 {
    height: 10px !important;
  }

  #sp-f9xti6 {
    height: 10px !important;
  }

  .sp-headline-block-qauwjx,
  #sp-qauwjx,
  #qauwjx {
    text-align: center !important;
  }

  .sp-text-wrapper-n51jiy,
  #sp-n51jiy,
  #n51jiy {
    text-align: left !important;
  }

  #sp-kgz2e9 {
    height: 10px !important;
  }

  #sp-n8ezo4 {
    height: 10px !important;
  }

  #sp-button-parent-uwxjkd {
    text-align: center !important;
  }

  .sp-text-wrapper-xtajmm,
  #sp-xtajmm,
  #xtajmm {
    text-align: left !important;
  }

  #sp-vkyt0u {
    height: 10px !important;
  }

  #sp-nxlmig {
    height: 10px !important;
  }

  #sp-q24ukq {
    height: 10px !important;
  }

  .sp-headline-block-xjet1i,
  #sp-xjet1i,
  #xjet1i {
    text-align: center !important;
  }

  .sp-text-wrapper-kxyn8o,
  #sp-kxyn8o,
  #kxyn8o {
    text-align: left !important;
  }

  #sp-button-parent-fgt5av {
    text-align: center !important;
  }

  #sp-ou64nh {
    height: 10px !important;
  }

  #sp-p19qjc {
    height: 10px !important;
  }

  #sp-hunfgw {
    height: 10px !important;
  }

  .sp-headline-block-g7siyz,
  #sp-g7siyz,
  #g7siyz {
    text-align: center !important;
  }

  #sp-kgqxw8 {
    height: 10px !important;
  }

  .sp-headline-block-ebuojp,
  #sp-ebuojp,
  #ebuojp {
    text-align: center !important;
  }

  .sp-text-wrapper-e2orzv,
  #sp-e2orzv,
  #e2orzv {
    text-align: left !important;
  }

  #sp-y4rndf {
    height: 10px !important;
  }

  #sp-m33z1h {
    height: 10px !important;
  }

  #sp-lkwjil {
    height: 10px !important;
  }

  .sp-headline-block-kr30a0,
  #sp-kr30a0,
  #kr30a0 {
    text-align: center !important;
  }

  .sp-text-wrapper-u0zpwt,
  #sp-u0zpwt,
  #u0zpwt {
    text-align: left !important;
  }

  #sp-f03md9 {
    height: 10px !important;
  }

  #sp-ben5ho .sp-skin-news .sp-posts-single-block {
    border-left: 0 !important;
  }

  #sp-uhmggu {
    height: 10px !important;
  }
}

#sp-cgvhiz {
  width: 100%;
  max-width: 100%;
  padding: 0;
}

#sp-bodumc {
  padding: 0;
  width: 100%;
  max-width: 100%;
}

#sp-ri084u {
  width: calc(100% - 0px);
  padding: 0;
}

#sp-qdze2v {
  margin: 0;
}

body {
  color: #353535;
  background-color: #fff !important;
  background-image: none;
  font-family: inter;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 1.6;
}

.sp-el-row {
  max-width: 1280px;
}

#primary.content-area {
  max-width: 1180px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: #171717;
  font-weight: 700;
  font-style: normal;
}

a {
  color: #16a34a;
}

a:hover {
  color: #2a712d;
  text-decoration: none;
}

label {
  font-size: 14px;
  font-weight: 700;
}

::placeholder {
  color: rgba(72, 72, 72, 0.5) !important;
}

.sp-button,
.edd-add-to-cart,
#edd-purchase-button,
.edd-submit,
[type="submit"].edd-submit,
#edd-save-cart-button,
#edd_next_button,
input[type="submit"],
.woocommerce #respond input#submit,
.woocommerce a.button,
.woocommerce button.button,
.woocommerce input.button {
  color: #fff;
  background-color: #16a34a;
  border-radius: 5px;
  border-width: 0;
  border-style: solid;
}

.sp-button:hover {
  background-color: #168940;
  color: #fff;
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="url"],
input[type="date"],
input[type="month"],
input[type="time"],
input[type="datetime"],
input[type="datetime-local"],
input[type="week"],
input[type="number"],
input[type="search"],
input[type="tel"],
input[type="color"],
select,
textarea,
.woocommerce input,
.woocommerce select,
.woocommerce textarea {
  color: #484848;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  padding: 7px;
  font-family: inter;
  font-weight: 400;
  font-style: normal;
}

.btn {
  background-color: #16a34a;
}

@media (max-width: 480px) {
  body {
    font-size: 14px;
    line-height: 1.6;
    background-color: #fff;
  }

  .sp-cd-amount {
    background-color: #16a34a;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/hero-pablooprod/style-global.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,MAAM;EACN,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;;;IAGE,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;IAGE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;;IAGE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA;;;IAGE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;EAME,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;EAmBE,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["#sp-ben5ho .sp-posts-single-block {\n  border-radius: 7px;\n  padding: 13px;\n  margin-bottom: 0;\n}\n\n#sp-ben5ho .sp-posts-single-block.sp-news-posts:nth-of-type(3n + 1) {\n  border-left: 0;\n}\n\n#sp-ben5ho\n  .sp-layout-gridlayout\n  .sp-posts-single-block.sp-minimal-posts:nth-child(-n + 3),\n#sp-ben5ho\n  .sp-layout-masonary\n  .sp-posts-single-block.sp-minimal-posts:nth-child(-n + 3) {\n  border-top: 0;\n}\n\n#sp-ben5ho .sp-layout-carousel .sp-posts-single-block.sp-minimal-posts {\n  border-top: 0;\n}\n\n#sp-ben5ho .sp-posts-image {\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n#sp-ben5ho .sp-posts-image-link {\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n  margin: 0;\n}\n\n#sp-ben5ho .sp-thumbnail {\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n#sp-ben5ho .sp-posts-block-title {\n  text-align: left;\n  font-size: 20px;\n  font-weight: 700;\n  color: #374151;\n}\n\n#sp-ben5ho .sp-posts-block-meta-text {\n  text-align: left;\n}\n\n#sp-ben5ho .sp-posts-block-excerpt {\n  text-align: left;\n}\n\n#sp-ben5ho .sp-posts-block-read-more {\n  text-align: left;\n}\n\n#sp-ben5ho .sp-posts-block-pagination {\n  text-align: left;\n  font-size: px;\n}\n\n#sp-ben5ho .sp-posts-single-block .sp-container-badge {\n  display: inline-block;\n  color: #fff;\n  background-color: #333;\n  margin-bottom: undefinedpx;\n}\n\n#sp-ben5ho .sp-posts-single-block .sp-container-badge a {\n  color: #fff;\n}\n\n#sp-ben5ho .sp-skin-block.sp-layout-carousel {\n  gap: 0;\n  flex-direction: column;\n}\n\n#sp-ben5ho .sp-skin-block.sp-layout-carousel .sp-postblock-nav {\n  justify-content: center;\n}\n\n#sp-bf2x0i {\n  background-color: #fff4e4;\n  width: 100%;\n  max-width: 100%;\n  padding: 10px;\n}\n\n#sp-b3j1ub {\n  width: calc(100% + 0px);\n}\n\n#sp-6r7flvguzh {\n  z-index: 0;\n}\n\n#sp-bwgiu8ve02 {\n  z-index: 0;\n}\n\n#sp-teojeb {\n  height: 40px;\n}\n\n#sp-ds689z {\n  font-size: 48px;\n  text-align: center;\n  margin: 0;\n}\n\n#sp-ut06xj {\n  font-size: 18px;\n  padding: 3px 0 0;\n  margin: 0;\n  text-align: center;\n}\n\n#sp-wb3isz {\n  height: 0;\n}\n\n#sp-w0z2ku {\n  width: auto;\n  max-width: 850px;\n}\n\n@media (max-width: 768px) {\n  #sp-w0z2ku {\n    width: auto;\n    max-width: 350px;\n    margin-bottom: 20px;\n  }\n}\n\n#sp-fbjtpp {\n  width: calc(16.6667% + 0px);\n}\n\n#sp-rx7rbcq36q {\n  z-index: 0;\n}\n\n#sp-noip8gjbhf {\n  z-index: 0;\n}\n\n#sp-c3954l {\n  margin: 0;\n  text-align: center;\n}\n\n#sp-8qg7evbmks {\n  width: 45px;\n}\n\n#sp-rcew2o {\n  line-height: 1.3;\n  font-size: 14px;\n  padding: 2px 0 0;\n  margin: 0;\n  text-align: center;\n}\n\n#sp-h6bm4c {\n  width: calc(16.6667% + 0px);\n}\n\n#sp-75ks273nhs {\n  z-index: 0;\n}\n\n#sp-iuk0yz45fv {\n  z-index: 0;\n}\n\n#sp-anpbod {\n  margin: 0;\n  text-align: center;\n}\n\n#sp-tgqd43uxxr {\n  width: 44px;\n}\n\n#sp-z7izeg {\n  line-height: 1.3;\n  font-size: 14px;\n  padding: 2px 0 0;\n  margin: 0;\n  text-align: center;\n}\n\n#sp-w3r3vo {\n  width: calc(16.6667% + 0px);\n}\n\n#sp-2627k6knak {\n  z-index: 0;\n}\n\n#sp-ek25ed39xq {\n  z-index: 0;\n}\n\n#sp-eo00pm {\n  margin: 0;\n  text-align: center;\n}\n\n#sp-8rniogyxaz {\n  width: 45px;\n}\n\n#sp-x3lz7g {\n  line-height: 1.3;\n  font-size: 14px;\n  padding: 2px 0 0;\n  margin: 0;\n  text-align: center;\n}\n\n#sp-w7f6ni {\n  width: calc(16.6667% + 0px);\n}\n\n#sp-57tae757ul {\n  z-index: 0;\n}\n\n#sp-92wt676ghl {\n  z-index: 0;\n}\n\n#sp-rxxrmh {\n  margin: 0;\n  text-align: center;\n}\n\n#sp-w7exd9s190 {\n  width: 44px;\n}\n\n#sp-gugx9z {\n  line-height: 1.3;\n  font-size: 14px;\n  padding: 2px 0 0;\n  margin: 0;\n  text-align: center;\n}\n\n#sp-kp3890 {\n  width: calc(16.6667% + 0px);\n}\n\n#sp-c28tj6pyqc {\n  z-index: 0;\n}\n\n#sp-7sg8l5x19l {\n  z-index: 0;\n}\n\n#sp-bn2fcb {\n  margin: 0;\n  text-align: center;\n}\n\n#sp-4paaylpy56 {\n  width: 44px;\n}\n\n#n3bicd {\n  line-height: 1.3;\n  font-size: 14px;\n  padding: 2px 0 0;\n  margin: 0;\n  text-align: center;\n  position: relative;\n}\n\n#sp-m64u5n {\n  width: calc(16.6667% + 0px);\n}\n\n#sp-v9zbz4zfds {\n  z-index: 0;\n}\n\n#sp-35ryj8r7un {\n  z-index: 0;\n}\n\n#sp-seomfz {\n  margin: 0;\n  text-align: center;\n}\n\n#sp-istm31lqm1 {\n  width: 44px;\n}\n\n#sp-lbrdh0 {\n  line-height: 1.3;\n  font-size: 14px;\n  padding: 2px 0 0;\n  margin: 0;\n  text-align: center;\n}\n\n#sp-ui35qo {\n  width: calc(100% + 0px);\n}\n\n@media only screen and (max-width: 768px) {\n  #mobile-margin {\n    margin-top: -20px;\n  }\n}\n\n#sp-vqh2jd1uj8 {\n  z-index: 0;\n}\n\n#sp-xbkc7v8bui {\n  z-index: 0;\n}\n\n#sp-pwnhx4 {\n  height: 0;\n}\n\n#sp-button-parent-cii6rt {\n  margin: 0;\n  text-align: center;\n}\n\n#sp-cii6rt {\n  font-size: 20px;\n  width: auto;\n  padding: 22px 66px;\n  border-radius: 32px;\n}\n\n#sp-rufcae {\n  height: 20px;\n}\n\n#sp-bjowye {\n  height: 0;\n}\n\n#sp-aqq5vl {\n  /* padding: 0; */\n  /* width: auto; */\n  max-width: 600px;\n}\n\n@media (max-width: 768px) {\n  #sp-aqq5vl {\n    /* padding: 0; */\n    /* width: auto; */\n    max-width: 75%;\n    margin-top: 40px;\n    margin-bottom: 20px;\n  }\n}\n\n/* Styles for web view */\n#sp-cgf214 {\n  width: calc(100% + 0px);\n}\n\n#sp-cgf214 .woocommerce-logo,\n#sp-cgf214 .shopify-badge,\n#sp-cgf214 .pabloo-trust {\n  width: 183px;\n  object-fit: contain;\n  border-radius: 9999px;\n}\n\n#sp-cgf214 .bg-white {\n  background-color: white;\n  border-radius: 9999px;\n}\n\n#sp-cgf214 .px-4 {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n/* Mobile-specific styles */\n@media (max-width: 768px) {\n  #sp-cgf214 {\n    grid-template-columns: 1fr !important;\n    gap: 0px !important;\n  }\n\n  #sp-cgf214 .woocommerce-logo,\n  #sp-cgf214 .shopify-badge,\n  #sp-cgf214 .pabloo-trust {\n    width: 90% !important;\n    padding-left: 16px;\n    padding-right: 16px;\n    border-radius: 75px;\n  }\n\n  #sp-cgf214 .flex {\n    margin-top: 25px !important;\n  }\n\n  #sp-cgf214 .px-4 {\n    padding-top: 10px;\n    padding-bottom: 10x;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n#sp-d86i01 {\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n\n#sp-eyokvw3gyu {\n  width: 183px;\n  height: 46px;\n}\n\n#sp-kjpg6v {\n  margin: 0;\n  padding: 0 0 0 6px;\n  text-align: left;\n}\n\n#sp-jth55ps0gy {\n  width: 328px;\n  height: 41px;\n}\n\n#sp-p7wnaf {\n  margin: 0;\n  padding: 0 6px 0 0;\n  text-align: center;\n}\n\n#sp-aswsuum9u5 {\n  width: 163px;\n  height: 46px;\n}\n\n#sp-axynf7 {\n  background-color: #fff4e4;\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-f4lgtv {\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-axe4hs {\n  width: calc(100% + 0px);\n  padding: 0;\n}\n\n#sp-kf43a4 {\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n\n#sp-w05e0zi3qe {\n  width: 1304px;\n}\n\n#sp-g2xrn7 {\n  height: 7px;\n}\n\n#sp-p2wii1 {\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n}\n\n#sp-psqt4k {\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-om4w75 {\n  width: calc(100% + 0px);\n  padding: 0;\n}\n\n#sp-qdcv8r {\n  padding: 0;\n  margin: 0;\n  display: flex;\n}\n\n#sp-nxlmig {\n  height: 75px;\n}\n\n#sp-wyvbbw {\n  background-color: #e4f7ff;\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-a52czq {\n  width: calc(100% + 0px);\n}\n\n#sp-q24ukq {\n  height: 60px;\n}\n\n#sp-xjet1i {\n  text-align: center;\n  margin: 0;\n}\n\n#sp-kxyn8o {\n  font-size: 18px;\n  margin: 0;\n  text-align: center;\n}\n\n#sp-sxw0lf918d {\n  font-weight: 400;\n}\n\n#sp-yteg6e {\n  width: calc(100% + 0px);\n}\n\n#sp-ec3l9y {\n  margin: 0;\n}\n\n#sp-button-parent-fgt5av {\n  margin: 0;\n  text-align: center;\n}\n\n#sp-fgt5av {\n  font-size: 16px;\n  font-weight: 700;\n  width: auto;\n  padding: 20px 58px;\n  border-radius: 40px;\n}\n\n#sp-ou64nh {\n  height: 60px;\n}\n\n#sp-sctek0 {\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n}\n\n#sp-b51x9n {\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-an6u1r {\n  width: calc(100% + 0px);\n  padding: 0;\n}\n\n#sp-p19qjc {\n  height: 30px;\n}\n\n#sp-a2qycu {\n  padding: 0;\n  margin: 0;\n  display: flex;\n}\n\n#sp-vm8h5x {\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n}\n\n#sp-eicp6k {\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-jn2hwe {\n  width: calc(100% + 0px);\n  padding: 0;\n}\n\n#sp-hunfgw {\n  height: 20px;\n}\n\n#sp-g7siyz {\n  font-size: 40px;\n  text-align: center;\n  margin: 0;\n}\n\n#sp-k3rw5m {\n  padding: 0;\n  margin: 0;\n}\n\n#sp-jjcbou {\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-w8xtzn {\n  width: auto;\n  max-width: 900px;\n}\n\n#sp-zu6kzg {\n  width: calc(100% + 0px);\n}\n\n#sp-kgqxw8 {\n  height: 40px;\n}\n\n#sp-ebuojp {\n  font-size: 40px;\n  text-align: center;\n  margin: 0;\n}\n\n#sp-e2orzv {\n  font-size: 18px;\n  margin: 0;\n  text-align: center;\n}\n\n#sp-y4rndf {\n  height: 70px;\n}\n\n#sp-wzfbsu {\n  margin: 0;\n  font-size: 18px;\n  color: #1f2937;\n}\n\n#sp-vvgw7w32rg {\n  margin: 0 0 23px;\n}\n\n#sp-m7yjbiaxmc {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n#sp-acc-closed-icon-id-wzfbsu {\n  width: 36px;\n  line-height: 36px;\n  font-size: 18px;\n  color: #374151;\n}\n\n#sp-acc-open-icon-id-wzfbsu {\n  width: 36px;\n  line-height: 36px;\n  font-size: 18px;\n  color: #374151;\n}\n\n#sp-08jucskpu1 {\n  border-top: 1px solid #e5e7eb;\n}\n\n#sp-gwwo1k2dyi {\n  margin: 23px 0;\n}\n\n#sp-jfaptgn8xc {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n#sp-uuiiu84fk8 {\n  border-top: 1px solid #e5e7eb;\n}\n\n#sp-yhadsl6tl0 {\n  margin: 23px 0;\n}\n\n#sp-lygsb9n28i {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n#sp-koqyujheft {\n  border-top: 1px solid #e5e7eb;\n}\n\n#sp-m0i6i3xb5q {\n  margin: 23px 0;\n}\n\n#sp-1zpipmlay9 {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n#sp-f0sp5ggkq4 {\n  border-top: 1px solid #e5e7eb;\n}\n\n#sp-zejg8zspxd {\n  margin: 23px 0;\n}\n\n#sp-an5pwvxinw {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n#sp-7n766lnczk {\n  border-top: 1px solid #e5e7eb;\n}\n\n#sp-bhh1w8g7dl {\n  margin: 23px 0 0;\n}\n\n#sp-qf9cfrhtq4 {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n#sp-i1gsfyx5rw {\n  border-top: 0 solid #e5e7eb;\n}\n\n#sp-m33z1h {\n  height: 86px;\n}\n\n#sp-k2xwy0 {\n  background-color: #fff4e4;\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-w4snn8 {\n  width: auto;\n  max-width: 1000px;\n}\n\n#sp-yp6bi4 {\n  width: calc(100% + 0px);\n}\n\n#sp-txsx3txmn5 {\n  z-index: 0;\n}\n\n#sp-1jucvbedvk {\n  z-index: 0;\n}\n\n#sp-lkwjil {\n  height: 60px;\n}\n\n#sp-kr30a0 {\n  font-size: 40px;\n  text-align: center;\n  margin: 0;\n}\n\n#sp-u0zpwt {\n  font-size: 18px;\n  margin: 0;\n  text-align: left;\n}\n\n#sp-cq6xxxfmo5 {\n  text-align: center;\n}\n\n#sp-f03md9 {\n  height: 0;\n}\n\n#sp-ben5ho {\n  margin: 0;\n}\n\n#sp-uhmggu {\n  height: 200px;\n}\n\n@media only screen and (max-width: 480px) {\n  #sp-teojeb {\n    height: 5px !important;\n  }\n\n  .sp-headline-block-ds689z,\n  #sp-ds689z,\n  #ds689z {\n    font-size: 24px !important;\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-ut06xj,\n  #sp-ut06xj,\n  #ut06xj {\n    font-size: 16px !important;\n    text-align: left !important;\n  }\n\n  #sp-wb3isz {\n    height: 0 !important;\n  }\n\n  #sp-c3954l {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-rcew2o,\n  #sp-rcew2o,\n  #rcew2o {\n    text-align: left !important;\n  }\n\n  #sp-anpbod {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-z7izeg,\n  #sp-z7izeg,\n  #z7izeg {\n    text-align: left !important;\n  }\n\n  #sp-eo00pm {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-x3lz7g,\n  #sp-x3lz7g,\n  #x3lz7g {\n    text-align: left !important;\n  }\n\n  #sp-rxxrmh {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-gugx9z,\n  #sp-gugx9z,\n  #gugx9z {\n    text-align: left !important;\n  }\n\n  #sp-bn2fcb {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-n3bicd,\n  #sp-n3bicd,\n  #n3bicd {\n    text-align: left !important;\n  }\n\n  #sp-seomfz {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-lbrdh0,\n  #sp-lbrdh0,\n  #lbrdh0 {\n    text-align: left !important;\n  }\n\n  #sp-button-parent-cii6rt {\n    text-align: center !important;\n  }\n\n  #sp-rufcae {\n    height: 10px !important;\n  }\n\n  #sp-bjowye {\n    height: 0 !important;\n  }\n\n  #sp-d86i01 {\n    text-align: center !important;\n  }\n\n  #sp-kjpg6v {\n    text-align: center !important;\n  }\n\n  #sp-p7wnaf {\n    text-align: center !important;\n  }\n\n  #sp-kf43a4 {\n    text-align: center !important;\n  }\n\n  #sp-g2xrn7 {\n    height: 7px !important;\n  }\n\n  #sp-p2wii1 {\n    padding: 0 !important;\n  }\n\n  #sp-psqt4k {\n    padding: 0 !important;\n  }\n\n  #sp-om4w75 {\n    padding: 0 !important;\n  }\n\n  #sp-qdcv8r {\n    padding: 0 !important;\n  }\n\n  #sp-f9xti6 {\n    height: 0 !important;\n  }\n\n  .sp-headline-block-qauwjx,\n  #sp-qauwjx,\n  #qauwjx {\n    font-size: 22px !important;\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-n51jiy,\n  #sp-n51jiy,\n  #n51jiy {\n    text-align: center !important;\n  }\n\n  #sp-kgz2e9 {\n    height: 0 !important;\n  }\n\n  #sp-button-parent-uwxjkd {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-xtajmm,\n  #sp-xtajmm,\n  #xtajmm {\n    text-align: center !important;\n  }\n\n  #sp-vkyt0u {\n    height: 20px !important;\n  }\n\n  #sp-nxlmig {\n    height: 10px !important;\n  }\n\n  #sp-q24ukq {\n    height: 10px !important;\n  }\n\n  .sp-headline-block-xjet1i,\n  #sp-xjet1i,\n  #xjet1i {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-kxyn8o,\n  #sp-kxyn8o,\n  #kxyn8o {\n    text-align: center !important;\n  }\n\n  #sp-button-parent-fgt5av {\n    text-align: center !important;\n  }\n\n  #sp-ou64nh {\n    height: 10px !important;\n  }\n\n  #sp-sctek0 {\n    padding: 0 !important;\n  }\n\n  #sp-b51x9n {\n    padding: 0 !important;\n  }\n\n  #sp-an6u1r {\n    padding: 0 !important;\n  }\n\n  #sp-p19qjc {\n    height: 10px !important;\n  }\n\n  #sp-a2qycu {\n    padding: 0 !important;\n  }\n\n  #sp-gi9fil {\n    height: 30px !important;\n  }\n\n  .sp-headline-block-x353y1,\n  #sp-x353y1,\n  #x353y1 {\n    font-size: 22px !important;\n    line-height: 1.2 !important;\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-ygedsp,\n  #sp-ygedsp,\n  #ygedsp {\n    text-align: left !important;\n  }\n\n  #sp-qp2g5t {\n    height: 0 !important;\n  }\n\n  #sp-obzcdd {\n    text-align: center !important;\n  }\n\n  .sp-headline-block-vniws6,\n  #sp-vniws6,\n  #vniws6 {\n    font-size: 18px !important;\n    text-align: left !important;\n  }\n\n  #sp-r5wo9a {\n    height: 6px !important;\n  }\n\n  .sp-text-wrapper-pzvg6s,\n  #sp-pzvg6s,\n  #pzvg6s {\n    font-size: 14px !important;\n    text-align: left !important;\n  }\n\n  .sp-headline-block-m0x996,\n  #sp-m0x996,\n  #m0x996 {\n    font-size: 18px !important;\n    text-align: left !important;\n  }\n\n  .sp-text-wrapper-p7gy29,\n  #sp-p7gy29,\n  #p7gy29 {\n    font-size: 14px !important;\n    text-align: left !important;\n  }\n\n  #sp-o40lfw {\n    text-align: center !important;\n  }\n\n  #sp-ozw1av {\n    text-align: center !important;\n  }\n\n  .sp-headline-block-pjvos7,\n  #sp-pjvos7,\n  #pjvos7 {\n    font-size: 18px !important;\n    text-align: left !important;\n  }\n\n  .sp-text-wrapper-i51n7b,\n  #sp-i51n7b,\n  #i51n7b {\n    font-size: 14px !important;\n    text-align: left !important;\n  }\n\n  .sp-headline-block-d7ygke,\n  #sp-d7ygke,\n  #d7ygke {\n    font-size: 18px !important;\n    text-align: left !important;\n  }\n\n  .sp-text-wrapper-jm0s0m,\n  #sp-jm0s0m,\n  #jm0s0m {\n    font-size: 14px !important;\n    text-align: left !important;\n  }\n\n  #sp-lsqp5w {\n    text-align: center !important;\n  }\n\n  #sp-dggsq5 {\n    text-align: center !important;\n  }\n\n  .sp-headline-block-q71rdl,\n  #sp-q71rdl,\n  #q71rdl {\n    font-size: 18px !important;\n    text-align: left !important;\n  }\n\n  .sp-text-wrapper-vd2gnm,\n  #sp-vd2gnm,\n  #vd2gnm {\n    font-size: 14px !important;\n    text-align: left !important;\n  }\n\n  .sp-headline-block-t2cyfz,\n  #sp-t2cyfz,\n  #t2cyfz {\n    font-size: 18px !important;\n    text-align: left !important;\n  }\n\n  .sp-text-wrapper-zaae5j,\n  #sp-zaae5j,\n  #zaae5j {\n    font-size: 14px !important;\n    text-align: left !important;\n  }\n\n  #sp-s1wtzk {\n    text-align: center !important;\n  }\n\n  #sp-hunfgw {\n    height: 10px !important;\n  }\n\n  .sp-headline-block-g7siyz,\n  #sp-g7siyz,\n  #g7siyz {\n    font-size: 22px !important;\n    text-align: center !important;\n  }\n\n  #sp-kgqxw8 {\n    height: 40px !important;\n  }\n\n  .sp-headline-block-ebuojp,\n  #sp-ebuojp,\n  #ebuojp {\n    font-size: 22px !important;\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-e2orzv,\n  #sp-e2orzv,\n  #e2orzv {\n    font-size: 14px !important;\n    text-align: center !important;\n  }\n\n  #sp-y4rndf {\n    height: 20px !important;\n  }\n\n  #sp-wzfbsu {\n    font-size: 14px !important;\n  }\n\n  #sp-m33z1h {\n    height: 40px !important;\n  }\n\n  #sp-lkwjil {\n    height: 20px !important;\n  }\n\n  .sp-headline-block-kr30a0,\n  #sp-kr30a0,\n  #kr30a0 {\n    font-size: 22px !important;\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-u0zpwt,\n  #sp-u0zpwt,\n  #u0zpwt {\n    font-size: 14px !important;\n    text-align: left !important;\n  }\n\n  #sp-f5tl4t {\n    padding: 0 !important;\n  }\n\n  #sp-s41od9 {\n    padding: 0 !important;\n  }\n\n  #sp-ben5ho {\n    padding: 0 !important;\n  }\n\n  #sp-ben5ho .sp-skin-news .sp-posts-single-block {\n    border-left: 0 !important;\n  }\n\n  #sp-ben5ho .sp-posts-block-title {\n    font-size: 18px !important;\n    text-align: center !important;\n  }\n\n  #sp-ben5ho .sp-posts-block-meta-text {\n    text-align: center !important;\n  }\n\n  #sp-ben5ho .sp-posts-single-block .sp-container-badge,\n  #sp-ben5ho .sp-posts-single-block .sp-container-badge a {\n    text-align: center !important;\n  }\n\n  #sp-ben5ho .sp-posts-block-excerpt {\n    text-align: center !important;\n  }\n\n  #sp-ben5ho .sp-posts-block-read-more {\n    text-align: center !important;\n  }\n\n  #sp-ben5ho .sp-posts-block-pagination {\n    text-align: center !important;\n  }\n\n  #sp-uhmggu {\n    height: 60px !important;\n  }\n}\n\n@media only screen and (min-width: 481px) and (max-width: 1024px) {\n  #sp-teojeb {\n    height: 10px !important;\n  }\n\n  .sp-headline-block-ds689z,\n  #sp-ds689z,\n  #ds689z {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-ut06xj,\n  #sp-ut06xj,\n  #ut06xj {\n    text-align: left !important;\n  }\n\n  #sp-wb3isz {\n    height: 10px !important;\n  }\n\n  #sp-c3954l {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-rcew2o,\n  #sp-rcew2o,\n  #rcew2o {\n    text-align: left !important;\n  }\n\n  #sp-anpbod {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-z7izeg,\n  #sp-z7izeg,\n  #z7izeg {\n    text-align: left !important;\n  }\n\n  #sp-eo00pm {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-x3lz7g,\n  #sp-x3lz7g,\n  #x3lz7g {\n    text-align: left !important;\n  }\n\n  #sp-rxxrmh {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-gugx9z,\n  #sp-gugx9z,\n  #gugx9z {\n    text-align: left !important;\n  }\n\n  #sp-bn2fcb {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-n3bicd,\n  #sp-n3bicd,\n  #n3bicd {\n    text-align: left !important;\n  }\n\n  #sp-seomfz {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-lbrdh0,\n  #sp-lbrdh0,\n  #lbrdh0 {\n    text-align: left !important;\n  }\n\n  #sp-pwnhx4 {\n    height: 10px !important;\n  }\n\n  #sp-button-parent-cii6rt {\n    text-align: center !important;\n  }\n\n  #sp-rufcae {\n    height: 10px !important;\n  }\n\n  #sp-bjowye {\n    height: 10px !important;\n  }\n\n  #sp-d86i01 {\n    text-align: center !important;\n  }\n\n  #sp-kjpg6v {\n    text-align: center !important;\n  }\n\n  #sp-p7wnaf {\n    text-align: center !important;\n  }\n\n  #sp-kf43a4 {\n    text-align: center !important;\n  }\n\n  #sp-g2xrn7 {\n    height: 10px !important;\n  }\n\n  #sp-f9xti6 {\n    height: 10px !important;\n  }\n\n  .sp-headline-block-qauwjx,\n  #sp-qauwjx,\n  #qauwjx {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-n51jiy,\n  #sp-n51jiy,\n  #n51jiy {\n    text-align: left !important;\n  }\n\n  #sp-kgz2e9 {\n    height: 10px !important;\n  }\n\n  #sp-n8ezo4 {\n    height: 10px !important;\n  }\n\n  #sp-button-parent-uwxjkd {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-xtajmm,\n  #sp-xtajmm,\n  #xtajmm {\n    text-align: left !important;\n  }\n\n  #sp-vkyt0u {\n    height: 10px !important;\n  }\n\n  #sp-nxlmig {\n    height: 10px !important;\n  }\n\n  #sp-q24ukq {\n    height: 10px !important;\n  }\n\n  .sp-headline-block-xjet1i,\n  #sp-xjet1i,\n  #xjet1i {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-kxyn8o,\n  #sp-kxyn8o,\n  #kxyn8o {\n    text-align: left !important;\n  }\n\n  #sp-button-parent-fgt5av {\n    text-align: center !important;\n  }\n\n  #sp-ou64nh {\n    height: 10px !important;\n  }\n\n  #sp-p19qjc {\n    height: 10px !important;\n  }\n\n  #sp-hunfgw {\n    height: 10px !important;\n  }\n\n  .sp-headline-block-g7siyz,\n  #sp-g7siyz,\n  #g7siyz {\n    text-align: center !important;\n  }\n\n  #sp-kgqxw8 {\n    height: 10px !important;\n  }\n\n  .sp-headline-block-ebuojp,\n  #sp-ebuojp,\n  #ebuojp {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-e2orzv,\n  #sp-e2orzv,\n  #e2orzv {\n    text-align: left !important;\n  }\n\n  #sp-y4rndf {\n    height: 10px !important;\n  }\n\n  #sp-m33z1h {\n    height: 10px !important;\n  }\n\n  #sp-lkwjil {\n    height: 10px !important;\n  }\n\n  .sp-headline-block-kr30a0,\n  #sp-kr30a0,\n  #kr30a0 {\n    text-align: center !important;\n  }\n\n  .sp-text-wrapper-u0zpwt,\n  #sp-u0zpwt,\n  #u0zpwt {\n    text-align: left !important;\n  }\n\n  #sp-f03md9 {\n    height: 10px !important;\n  }\n\n  #sp-ben5ho .sp-skin-news .sp-posts-single-block {\n    border-left: 0 !important;\n  }\n\n  #sp-uhmggu {\n    height: 10px !important;\n  }\n}\n\n#sp-cgvhiz {\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n}\n\n#sp-bodumc {\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n#sp-ri084u {\n  width: calc(100% - 0px);\n  padding: 0;\n}\n\n#sp-qdze2v {\n  margin: 0;\n}\n\nbody {\n  color: #353535;\n  background-color: #fff !important;\n  background-image: none;\n  font-family: inter;\n  font-weight: 400;\n  font-style: normal;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n.sp-el-row {\n  max-width: 1280px;\n}\n\n#primary.content-area {\n  max-width: 1180px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #171717;\n  font-weight: 700;\n  font-style: normal;\n}\n\na {\n  color: #16a34a;\n}\n\na:hover {\n  color: #2a712d;\n  text-decoration: none;\n}\n\nlabel {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n::placeholder {\n  color: rgba(72, 72, 72, 0.5) !important;\n}\n\n.sp-button,\n.edd-add-to-cart,\n#edd-purchase-button,\n.edd-submit,\n[type=\"submit\"].edd-submit,\n#edd-save-cart-button,\n#edd_next_button,\ninput[type=\"submit\"],\n.woocommerce #respond input#submit,\n.woocommerce a.button,\n.woocommerce button.button,\n.woocommerce input.button {\n  color: #fff;\n  background-color: #16a34a;\n  border-radius: 5px;\n  border-width: 0;\n  border-style: solid;\n}\n\n.sp-button:hover {\n  background-color: #168940;\n  color: #fff;\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"email\"],\ninput[type=\"url\"],\ninput[type=\"date\"],\ninput[type=\"month\"],\ninput[type=\"time\"],\ninput[type=\"datetime\"],\ninput[type=\"datetime-local\"],\ninput[type=\"week\"],\ninput[type=\"number\"],\ninput[type=\"search\"],\ninput[type=\"tel\"],\ninput[type=\"color\"],\nselect,\ntextarea,\n.woocommerce input,\n.woocommerce select,\n.woocommerce textarea {\n  color: #484848;\n  background-color: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 5px;\n  padding: 7px;\n  font-family: inter;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.btn {\n  background-color: #16a34a;\n}\n\n@media (max-width: 480px) {\n  body {\n    font-size: 14px;\n    line-height: 1.6;\n    background-color: #fff;\n  }\n\n  .sp-cd-amount {\n    background-color: #16a34a;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
